import React from 'react';
import { connect } from 'react-redux';
import { trans } from '../localization/language';
import { timestampToString } from '../utils';

class SensitiveOperation extends React.Component {
	renderTitle() {
		return (
			<div className="content-item__title">
				{trans('sensitive_operation')}
			</div>
		);
	}

	renderPanel() {
		return (
			<div className="oplog-panel">
				<div className="oplog-panel__txt">
					{trans('sensitive_ops_panel_text')}
				</div>
			</div>
		);
	}

	renderTableHead() {
		return (
			<div className="oplog-table__thead">
				<div className="oplog-table__row">
					<div className="oplog-table__th oplog-table__date">{trans('date_time')}</div>
					<div className="oplog-table__th oplog-table__country">{trans('country')}</div>
					<div className="oplog-table__th oplog-table__ip">IP</div>
					<div className="oplog-table__th oplog-table__opsrc">{trans('operation')}</div>
				</div>
			</div>
		);
	}

	renderTableRow(date, country, ip, operation, index) {
		return (
			<div className="oplog-table__row oplog-table__tdrow" key={index}>
				<div className="oplog-table__td oplog-table__date">{date}</div>
				<div className="oplog-table__td oplog-table__country">{country}</div>
				<div className="oplog-table__td oplog-table__ip">{ip}</div>
				<div className="oplog-table__td oplog-table__opsrc">{trans(operation)}</div>
			</div>
		);
	}

	renderTableBody() {
		var logs = [];
		this.props.sensitiveOps.forEach(function(log, index){
			if((new Date() - new Date(log.timestamp * 1000))/1000/60/60/24 <= 28)
				logs.push(this.renderTableRow(timestampToString(log.timestamp), log.country, log.ip, log.operation, index));
		}, this);
		return (
			<div className="oplog-table__tbody">
				{logs}
			</div>
		);
	}

	renderLogTable() {
		return (
			<div className="oplog-table">
				{this.renderTableHead()}
				{this.renderTableBody()}
			</div>
		);
	}
	
	renderListRow(date, country, ip, operation, index) {
		return (
			<div className="oplog-list__row" key={index}>
				<div className="oplog-list__row-info">
					<div className="oplog-list__row-l">{date}</div>
					<div className="oplog-list__row-r">{trans(operation)}</div>
				</div>
				<div className="oplog-list__row-location">{ip} {country?'('+country+')':''}</div>
			</div>
		);
	}
	
	renderLogList() {
		var logs = [];
		this.props.sensitiveOps.forEach(function(log, index){
			if((new Date() - new Date(log.timestamp * 1000))/1000/60/60/24 <= 28)
				logs.push(this.renderListRow(timestampToString(log.timestamp), log.country, log.ip, log.operation, index));
		}, this);
		return (
			<div className="oplog-list">
				{logs}
			</div>
		);
	}

	renderLogData() {
		return (
			<div className="oplog-data">
				{this.renderLogTable()}
				{this.renderLogList()}
			</div>
		);
	}

	renderMain() {
		return (
			<div className="oplog-wrap oplog-wrap--expanded">
				<div className="content-item__main">
					<div className="oplog">
						{this.renderPanel()}
						{this.renderLogData()}
					</div>
				</div>
			</div>
		);
	}

	render() {
		return (
			<div className="main">
				<div className="content">
					<div className="content-item">
						{this.renderTitle()}
						{this.renderMain()}
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo,
		sensitiveOps: state.data.sensitiveOps
	}
}

export default connect(mapStateToProps)(SensitiveOperation);


// WEBPACK FOOTER //
// ./app/components/SensitiveOperation.js